import {Container} from "semantic-ui-react";
import OfferCards from "../components/offer_cards";
import OfferPagination from "../components/offer_pagination";
import OfferLoading from "../components/offer_loading";
import React, {useState} from "react";
import useFetchOffers from "../hooks/useFetchOffers";
import Layout from "../components/layout";
import SearchAndFilter from "../components/search_and_filter";
import { useSearchParams } from "react-router-dom";


const OfferPage = ({is_mobile}) => {
  const [offer_data, setOfferData] = useState({
    offers: [], featured_offers: [], count: 0, offer_loading: true
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams])
  const [query, setQuery] = useState({
    page: 0,
    search_query: 'search_query' in params ? params['search_query'] : '',
    title: 'title' in params ? params['title'] === 'true' : false,
    days: 'days' in params && !isNaN(params['days']) && ['1', '7', '30', '90', '180'].includes(params['days']) ? +params['days'] : 30,
    remote: 'remote' in params ? params['remote'] === 'true' : false,
    job_type: 'job_type' in params ? params['job_type'] : '',
    language: 'language' in params ? params['language'] : '',
    search_location_query: 'search_location_query' in params ? params['search_location_query'] : '',
  })

  useFetchOffers(
      setOfferData, setSearchParams, query.page, query.search_query, query.title,
      query.days, query.remote, query.job_type, query.language,
      query.search_location_query
  )

  return (
      <Layout offer_loading={offer_data.offer_loading} offers_length={offer_data.offers.length} is_mobile={is_mobile}>
        <Container text>
          <SearchAndFilter
              offers_total_count={offer_data.count}
              is_mobile={is_mobile}
              setQuery={setQuery}
              query={query}
              params={params}
          />
          <OfferLoading offerLoading={offer_data.offer_loading}/>
          <OfferCards is_mobile={is_mobile} offers={offer_data.featured_offers}/>
          <OfferCards is_mobile={is_mobile} offers={offer_data.offers}/>
          <OfferPagination page={query.page} setQuery={setQuery} is_mobile={is_mobile}/>
        </Container>
      </Layout>
  )
}

export default OfferPage;